export default __webpack_public_path__ + "static/media/lutzen.02c5c542.png";